import { withInstall } from '@ll-plus/utils'

import Watermark from './src/watermark.vue'

export const LlWatermark = withInstall(Watermark)

export default LlWatermark

export * from './src/watermark'

declare module 'vue' {
  export interface GlobalComponents {
    LlWatermark: typeof Watermark
  }
}
